export default __webpack_public_path__ + "static/media/pricingBg.c31cf700.webp";